// extracted by mini-css-extract-plugin
module.exports = {"Td":"ItemTable_Td__1OBhs","Table":"ItemTable_Table__1RulT"};